/** import external dependencies */
import $ from 'jquery/dist/jquery.js';
import "waypoints/lib/jquery.waypoints.min";
import 'jquery-validation/dist/jquery.validate';
import "prcomboselect";

/** import local dependencies */
import Router from './util/Router';
import common from './routes/common';
import pageTemplateTemplateHome from './routes/home';
import pageTemplateTemplateAboutUs from "./routes/about-us";
import pageTemplateTemplateInvestments from "./routes/investments";
import pageTemplateTemplateInvestmentsDetail from "./routes/investments"; // backend: feel free to delete only made it because client wanted to see on frontend link
import pageTemplateTemplateLanding from "./routes/landing";
import pageTemplateTemplateContact from "./routes/contact";
import pageTemplateTemplateResources from "./routes/resources";
import archive from "./routes/resources";
import pageTemplateTemplateResourcesDetail from "./routes/resources-detail";

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	pageTemplateTemplateHome,
	pageTemplateTemplateAboutUs,
	pageTemplateTemplateInvestments,
	pageTemplateTemplateLanding,
	pageTemplateTemplateContact,
	pageTemplateTemplateResources,
	archive,
	pageTemplateTemplateResourcesDetail,
	pageTemplateTemplateInvestmentsDetail
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js